import { render, staticRenderFns } from "./PriceLink.vue?vue&type=template&id=99d40e02&scoped=true&"
import script from "./PriceLink.vue?vue&type=script&lang=ts&"
export * from "./PriceLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d40e02",
  null
  
)

export default component.exports